module.exports = __webpack_public_path__ + "img/1600-3_YR_2022_Money.a93936ee.png";